module.exports = __webpack_public_path__ + "static/media/dollar.9bdc2253.svg";